import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import MultiDatePicker from '../../components/DatePickers/MultiDatePicker';
import actions from './duck/actions';
import DataTable from '../../components/DataTable';
import { Breadcrumbs, Typography, Button, TextInput } from 'kangarootime-ui';
import RaisedContainer from '../../components/RaisedContainer';

class NewMenu extends Component {
  constructor (props) {
    super(props);

    this.state = {
      menuName: '',
      tableViewType: 'center',
      menuEntities: []
    };

    this.selectedMenuEntities = [];
    this.selectedMenuDates = [];
  }

  get date () {
    return new Date();
  }

  get breadcrumbs () {
    return [
      { label: 'Nutrition', link: null },
      { label: 'New Menu', link: null }
    ];
  }

  componentDidMount = () => {
    this.rowsForTable();
  }

  rowsForTable = () => {
    const { centers, rooms } = this.props;

    const formattedCenters = centers.map(center => ({
      id: center.id,
      name: center.name,
      type: 'Center'
    }));
    const formattedRooms = rooms.map(room => ({
      id: room.id,
      name: room.name,
      type: 'Room'
    }));

    this.setState({ menuEntities: [...formattedCenters, ...formattedRooms] });
  }

  handleDateSelection = dates => {
    // `dates` is an array of moment objects returned from `react-dates` calendar
    this.selectedMenuDates = dates;
  }

  handleTableSelection = data => {
    this.selectedMenuEntities = data;
  }

  renderSelectionTable = () => (
    <DataTable
      title='Select which room(s) to assign this menu to'
      columns={[
        { field: 'name', title: 'Name' },
        { field: 'type', title: 'Type' }
      ]}
      data={this.state.menuEntities}
      options={{ selection: true }}
      onSelectionChange={this.handleTableSelection}
    />
  );

  navigateToAddMeals = () => {
    const { menuName } = this.state;

    if (menuName.replace(' ', '').length === 0) {
      alert('Please name your menu');
      return;
    }
    if (this.selectedMenuEntities.length === 0) {
      alert('Please select who you would like this menu applied to');
      return;
    }

    if (this.selectedMenuDates.length === 0) {
      alert('Please select what dates you would like this menu applied to');
      return;
    }

    this.props.setMenuName(menuName);
    this.props.setMenuDates(this.selectedMenuDates);
    this.props.setMenuEntities(this.selectedMenuEntities);
    this.props.history.push('/menus/new/meals');
  }

  render () {
    return (
      <NavigationBars>
        <div className='flex-columns flex-1'>
          <Breadcrumbs breadcrumbs={this.breadcrumbs} />
          <RaisedContainer>
            <div style={{ margin: 16 }}>
              <Typography type='header'>Create New Menu</Typography>
              <div className='flex-rows flex-1'>
                <div className='flex-columns flex-1'>
                  <TextInput
                    label='Menu Name'
                    helperText='What would like to call this menu?'
                    placeholder='Name'
                    value={this.state.menuName}
                    onChange={event => this.setState({ menuName: event.target.value })}
                  />
                  <div className='flex-columns flex-1' style={{ marginTop: 8 }}>
                    { this.renderSelectionTable() }
                  </div>
                </div>
                <div className='flex' style={{ flex: 0, marginLeft: 16 }}>
                  <div className='flex-columns'>
                    <Typography>What dates should this menu take effect on?</Typography>
                    <MultiDatePicker
                      disableToday={false}
                      date={this.date}
                      onChange={this.handleDateSelection}
                    />
                    <div className='flex-1 flex-columns' style={{ marginTop: 16, justifyContent: 'flex-end' }}>
                      <Typography type='header'>Add Meals</Typography>
                      <Button
                        type='primary'
                        onClick={this.navigateToAddMeals}
                        style={{ marginTop: 16 }}
                      >
                        Next
                      </Button>
                      <Button
                        type='secondary'
                        onClick={() => this.props.history.goBack()}
                        style={{ marginTop: 8 }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </RaisedContainer>
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    rooms: state.rooms.rooms.filter(room => room.name !== 'Floats'),
    centers: state.identity.centers
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setMenuName: name => dispatch(actions.setMenuName(name)),
    setMenuDates: dates => dispatch(actions.setMenuDates(dates)),
    setMenuEntities: entities => dispatch(actions.setMenuEntities(entities))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewMenu);
